import { type CreateSavedFilterResponse } from './useMutationCreateSavedFilter/types';
import { type QuerySavedFiltersResponse } from './useQuerySavedFilters/types';

/**
 * Merges the created saved filter into the cached saved-filter list.
 *
 * Inserts new filters at the top of the cached list and increments the
 * paginated count. If the created filter already exists in cache, replaces it
 * without changing the count.
 */
export function upsertCreatedSavedFilterInCache(
  previousCache: QuerySavedFiltersResponse | undefined,
  savedFilter: CreateSavedFilterResponse,
) {
  if (!previousCache) return previousCache;

  const savedFilterIndex = previousCache.data.findIndex(
    (cachedSavedFilter) => cachedSavedFilter.id === savedFilter.id,
  );

  if (savedFilterIndex === -1) {
    return {
      ...previousCache,
      data: [savedFilter, ...previousCache.data],
      paginatedCount: previousCache.paginatedCount + 1,
    } satisfies QuerySavedFiltersResponse;
  }

  return {
    ...previousCache,
    data: previousCache.data.map((cachedSavedFilter) =>
      cachedSavedFilter.id === savedFilter.id ? savedFilter : cachedSavedFilter,
    ),
  } satisfies QuerySavedFiltersResponse;
}
